<template>
	<div class="operation">
		<v-search-operation
			:operation="operation"
			:operType="operType"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:multipleSelection="multipleSelection"
			@update="currentChange"></v-search-operation>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="operationList"
				@selection-change="handleSelectionChange"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					type="selection"
					width="40"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="module"
					:label="$t('operation.title')"
					width="210"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('operation.businessType')"
					:formatter="dictFormat"
					width="120"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="reqFunc"
					:label="$t('operation.requestMethod')"
					width="140"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="operator"
					:label="$t('operation.operationName')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="ip"
					:label="$t('operation.operationIp')"
					width="130"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="locale"
					:label="$t('operation.operationLocation')"
					width="150"
					:align="'center'"></el-table-column>
				<el-table-column
					:label="$t('operation.opStatus')"
					width="140"
					:align="'center'">
					<template slot-scope="scope">
						{{
							scope.row.state === 0 ? $t("common.success") : $t("common.error")
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('operation.createTime')"
					width="160"
					:align="'center'"></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('operation.status')"
					width="100"
					:align="'center'">
					<template slot-scope="scope">
						<el-button size="mini" @click="getOperationInfo(scope.row)">{{
							$t("operation.info")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"></el-pagination>
		</div>
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('operation.dialogTitle')"
			:visible.sync="dialogVisible"
			width="50%"
			top="9vh"
			:before-close="handleClose">
			<vue-scroll style="height: 500px">
				<el-form
					label-position="top"
					ref="userForm"
					label-width="90px"
					size="mini">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('operation.opTitle') + ':'">
								{{ operationLog.module }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('operation.url') + ':'">
								{{ operationLog.url }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('operation.login') + ':'">
								{{ operationLog.operationName }} / {{ operationLog.ip }} /
								{{ operationLog.locale }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('operation.requestMethod') + ':'">
								{{ operationLog.reqFunc }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item :label="$t('operation.method') + ':'">
								{{ operationLog.method }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item :label="$t('operation.params') + ':'">
								<!--{{operationLog.params}}-->
								<!-- 982713897172389 -->
								<json-view :data="json.params"></json-view>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item :label="$t('operation.result') + ':'">
								<!--{{operationLog.jsonResult}}-->
								<json-view :data="json.jsonResult"></json-view>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('operation.opStatus') + ':'">
								{{
									operationLog.state === 0
										? $t("operation.normal")
										: $t("operation.abnormal")
								}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('operation.createTime') + ':'">
								{{ operationLog.createTime }}
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</vue-scroll>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{
					$t("common.cancel")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import vSearchOperation from "@/components/authority/log/SearchOperation";
import jsonView from "@/components/json-view/index.vue";

export default {
	name: "Operation",
	components: {
		vSearchOperation,
		jsonView,
	},
	data() {
		return {
			operationList: [],
			dialogVisible: false,
			loading: false,
			operationLog: Object,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			operation: {
				module: "",
				operator: "",
				type: "",
				startTime: "",
				endTime: "",
				state: "",
			},
			operType: [],
			multipleSelection: [],
			json: {
				jsonResult: Object,
				params: Object,
			},
		};
	},
	mounted() {
		this.currentChange();
		this.listDict();
	},
	methods: {
		listDict() {
			this.$api.dict("sys_operate").then(res => {
				if (res.code === 0) {
					this.operType = res.data;
				}
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = !this.loading;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			this.$api
				.request(
					this.$url.OperationLog.page,
					this.$method.get,
					this.$cloud.objMerge(this.operation, this.page)
				)
				.then(
					res => {
						if (res.code === 0) {
							if (res.data && res.data.records) {
								this.operationList = res.data.records;
								this.page.totalSize = parseInt(res.data.total);
							}
						}
						this.loading = !this.loading;
					},
					() => {
						this.loading = !this.loading;
					}
				);
		},

		getOperationInfo(row) {
			this.operationLog = row;
			this.dialogVisible = true;
			this.json.jsonResult = JSON.parse(row.rs);
			this.json.params = JSON.parse(row.querys);
		},

		handleSelectionChange(row) {
			this.multipleSelection = row;
		},

		dictFormat(row) {
			return this.$cloud.getDictLabel(this.operType, row.type);
		},

		handleClose() {
			this.dialogVisible = false;
		},

		onSubmit() {
			this.currentChange();
		},

		resetSearch() {
			this.currentChange();
		},
	},
};
</script>

<style lang="scss">
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
.operation {
	.el-form .el-row {
		margin-left: 0 !important;
		margin-right: 0 !important;
		.el-col {
			padding-left: 0 !important;
			padding-right: 0 !important;
		}
	}
}
</style>
